var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{'is-active': _vm.active},on:{"click":function($event){$event.stopPropagation();_vm.click($event)}}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2553b14a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/LocaleButton.vue
// module id = 339
// module chunks = 1